import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { VersionApi } from '@shared/models/version-api.model';
import { Version } from '@shared/models/version.model';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class VersionApiService {

  static readonly apiContext = 'versions';

  private readonly _api = inject(ApiService);

  get$(): Observable<Version[] | null> {
    return this._api
               .get<VersionApi[]>(VersionApiService.apiContext)
               .pipe(
                   map((items) => items
                                  ? items.map((item) => new Version(item))
                                  : null),
               );
  }
}
